import { Box, Flex, Text, Container, Image } from "@chakra-ui/react";
import React from "react";
import { Grid } from "@mantine/core";
import Parse from "parse";

export const ShowOffer = ({
  url,
  imageFile,
  nomOffre,
  contrat,
  nomEntreprise,
  adresseEntreprise,
  dateDebut,
  resume,
  duration,
  experience,
  salary,
  month,
  showMissionsLabel,
  missions,
}) => {
  const user = Parse.User.current();
  return (
    <Box
      bg={"white"}
      borderRadius="20px"
      borderColor={"red"}
      boxShadow="xl"
      height={["", "", "740px", "740px"]}
      w={["100%", "100%", "calc(100% - 100px)", "calc(100% - 100px)"]}
    >
      <Box
        bg="#007df7"
        height={"180px"}
        w="100%"
        borderRadius="20px"
        color={"white"}
        fontSize={"2xl"}
        fontWeight={"bold"}
      >
        <Container maxW="xl" align={"center"}>
          <Text
            fontSize={"24px"}
            fontWeight={900}
            fontFamily={"Sofia Pro"}
            pt={"40px"}
            color={"white"}
            noOfLines={1}
          >
            {nomOffre.length > 0 ? nomOffre : "_"}
          </Text>
          <Text
            fontSize={"24px"}
            fontWeight={900}
            fontFamily={"Sofia Pro"}
            color={"white"}
            pt={"10px"}
            noOfLines={1}
          >
            {contrat.length > 0 ? contrat : "_"}
          </Text>
          <Box
            mt={"20px"}
            h={"12px"}
            w={"65px"}
            borderRadius={"25px"}
            bg={"white"}
          ></Box>
        </Container>
      </Box>

      <Box h={["100%", "100%", "580px", "580px"]} w="100%">
        <Grid h={["", "", "100%", "100%"]} gutter="xl">
          <Grid.Col
            h={["", "", "100%", "100%"]}
            order={2}
            mt={"10px"}
            key="2"
            xs={8}
          >
            <Box ml={10}>
              <Text
                maxW={"740px"}
                fontSize={"24px"}
                fontWeight={900}
                fontFamily={"Sofia Pro"}
                noOfLines={1}
              >
                {nomEntreprise}
              </Text>
              <Text
                maxW={"740px"}
                noOfLines={1}
                fontSize={"18px"}
                fontWeight={400}
                fontFamily={"Sofia Pro"}
              >
                {adresseEntreprise}
              </Text>
              <Text
                maxW={"740px"}
                color={"#F1404B"}
                fontSize={"18px"}
                fontWeight={400}
                noOfLines={1}
                fontFamily={"Sofia Pro"}
              >
                {dateDebut
                  ? `A partir ${
                      ["04", "08", "10"].includes(month) ? "d'" : "de "
                    }`
                  : ""}
                {dateDebut}
              </Text>
              <Text
                maxW={"740px"}
                noOfLines={1}
                fontSize={"18px"}
                fontWeight={400}
                fontFamily={"Sofia Pro"}
              >
                {duration ? "(" + duration + ")" : ""}
              </Text>
              <Text
                maxW={"740px"}
                lineHeight={1.3}
                fontSize={"14px"}
                my={"5px"}
                fontWeight={400}
                fontFamily={"Sofia Pro"}
                noOfLines={6}
              >
                {resume}
              </Text>
              <Text
                maxW={"740px"}
                my={"5px"}
                fontSize={"18px"}
                fontWeight={900}
                fontFamily={"Sofia Pro"}
              >
                {showMissionsLabel ? "Missions proposées" : ""}
              </Text>
              <Text
                maxW={"740px"}
                fontSize={"14px"}
                fontWeight={400}
                lineHeight={1.3}
                fontFamily={"Sofia Pro"}
                noOfLines={6}
              >
                {missions}
              </Text>
              <Text
                maxW={"740px"}
                my={"5px"}
                fontSize={"18px"}
                fontWeight={900}
                fontFamily={"Sofia Pro"}
              >
                {experience ? "Experiences requises" : ""}
              </Text>
              <Text
                maxW={"740px"}
                fontSize={"14px"}
                lineHeight={1.3}
                fontWeight={400}
                noOfLines={6}
                fontFamily={"Sofia Pro"}
              >
                {experience}
              </Text>
            </Box>
          </Grid.Col>
          <Grid.Col
            order={1}
            orderLg={2}
            h={["", "", "100%", "100%"]}
            w={"100%"}
            key="1"
            xs={4}
          >
            <Flex
              h={["", "", "100%", "100%"]}
              w={"100%"}
              alignItems={"center"}
              justifyContent={"center"}
              flexDirection={"column"}
            >
              <Box
                width="200px"
                height="200px"
                bg={"white"}
                borderColor={"grey"}
                borderRadius={"20px"}
                boxShadow={"lg"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                {!imageFile ? (
                  ""
                ) : (
                  <Image
                    width="100px"
                    height="100px"
                    borderRadius={"5px"}
                    src={URL.createObjectURL(imageFile)}
                  ></Image>
                )}
                {!url ? (
                  ""
                ) : (
                  <Image borderRadius={"5px"} src={url} boxSize="100px" />
                )}
              </Box>
              <Flex
                pt={"20px"}
                alignItems={"center"}
                justifyContent={"center"}
                flexDirection={"column"}
              >
                <Text
                  maxW={"210px"}
                  fontSize={"18px"}
                  fontWeight={400}
                  fontFamily={"Sofia Pro"}
                  noOfLines={1}
                  color={"#CFCFCF"}
                >
                  Offre postée par
                </Text>
                <Text
                  maxW={"210px"}
                  fontSize={"18px"}
                  fontWeight={400}
                  fontFamily={"Sofia Pro"}
                  noOfLines={1}
                  color={"#CFCFCF"}
                >
                  {user.get("prenom")}
                </Text>
                <Text
                  maxW={"210px"}
                  fontSize={"18px"}
                  fontWeight={400}
                  fontFamily={"Sofia Pro"}
                  noOfLines={1}
                  color={"#CFCFCF"}
                >
                  pour {nomEntreprise}
                </Text>
              </Flex>
            </Flex>
          </Grid.Col>
        </Grid>
      </Box>
    </Box>
  );
};

export default ShowOffer;
